import { Order } from '@models/Order';
import { Typography } from 'antd';
import moment from 'moment';
import ActionColumn from './components/ActionColumn';
import { SearchOutlined } from '@ant-design/icons';
import TableFilters from '../../components/TableFilters';

const { Text } = Typography;

export const columns: any = [
  {
    title: 'Código',
    dataIndex: 'orderCode',
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
      <TableFilters
        inputPlaceholder={'Filtrar pelo código'}
        inputValue={selectedKeys[0]}
        onChangeInputValue={setSelectedKeys}
        onFilter={confirm}
        onClearFilters={clearFilters}
      />
    ),
    filterIcon: () => <SearchOutlined style={{ color: '#FFFFFF' }} />,
    onFilter: (value: any, record: any) => {
      return record.orderCode ? record.orderCode.toString().toLowerCase().includes(value.toLowerCase()) : false;
    },
    sorter: true,
  },
  {
    title: 'Lojista',
    dataIndex: 'customerName',
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
      <TableFilters
        inputPlaceholder={'Filtrar pelo Lojista'}
        inputValue={selectedKeys[0]}
        onChangeInputValue={setSelectedKeys}
        onFilter={confirm}
        onClearFilters={clearFilters}
      />
    ),
    filterIcon: () => <SearchOutlined style={{ color: '#FFFFFF' }} />,
    onFilter: (value: any, record: any) => {
      return record.customerName ? record.customerName.toLowerCase().includes(value.toLowerCase()) : false;
    },
    sorter: true,
  },
  {
    title: 'Valor Total',
    dataIndex: 'totalAmountOrder',
    // align: 'right' as 'right',
    render: (text: string) => <Text>R$ {Number(text).toFixed(2).toString().replace('.', ',')}</Text>,
    sorter: true,
  },
  {
    title: 'Data',
    dataIndex: 'orderDate',
    render: (text: string) => <Text>{moment.utc(text).format('DD/MM/YYYY')}</Text>,
    sorter: true,
  },
  {
    title: 'Status',
    dataIndex: 'statusOrder',
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
      <TableFilters
        inputPlaceholder={'Filtrar pelo Status'}
        inputValue={selectedKeys[0]}
        onChangeInputValue={setSelectedKeys}
        onFilter={confirm}
        onClearFilters={clearFilters}
      />
    ),
    filterIcon: () => <SearchOutlined style={{ color: '#FFFFFF' }} />,
    onFilter: (value: any, record: any) => {
      return record.statusOrder ? record.statusOrder.toString().toLowerCase().includes(value.toLowerCase()) : false;
    },
    sorter: true,
  },
  {
    title: 'Ações',
    render: (order: Order) => <ActionColumn order={order} />,
  },
];
